import React, { useEffect, useMemo } from "react";
import NewLogo from "../../components/CNLogo/NewLogo";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepProgressBar from "./StepProgressBar";
import StepThree from "./StepThree";
import StepFour from "./StepFour";
import FourFlows from "./FourFlows";
import { useDispatch, useSelector } from "react-redux";
import { SET_ONBOARDING_IS_LOADING, SET_ONBOARDING_MAX_PRODUCT, SET_ONBOARDING_STEP, SET_ONBOARDING_X_PRODUCT } from "../../redux/actions/types";
import BottomScroll from "./BottomScroll";
import StepFive from "./StepFive";
import OnboardingLoaders from "./Loaders";
import { getProductById } from "../../redux/actions/pricing";
import CertificateLoader from "./Loaders/CertificateLoader";
import CourseLoader from "./Loaders/CourseLoader";
import { checkUserAccess } from "../../redux/actions/authentication";
import { useNavigate } from "react-router-dom";

// Three-dot rotating loader for the bottom "Firing up personalisation engine..." state.
const PersonalisationLoader = ({text}) => {
  return (
    <div className="flex items-center gap-3">
      <div
        className="relative h-4 w-4 animate-spin"
        style={{ animationDuration: "1.4s", animationTimingFunction: "linear" }}
      >
        <span className="absolute top-0 left-1/2 h-1.5 w-1.5 -translate-x-1/2 rounded-full bg-[#2BBD13]" />
        <span className="absolute bottom-0 left-0 h-1.5 w-1.5 rounded-full bg-[#2BBD13]" />
        <span className="absolute bottom-0 right-0 h-1.5 w-1.5 rounded-full bg-[#2BBD13]" />
      </div>
      <p className="text-white/70 font-normal text-[12px]">
        {text}
      </p>
    </div>
  );
};

const OnboardingPage25 = () => {
  const step = useSelector((store) => store?.onBoarding?.step);
  const dispatch = useDispatch();
  const secondBranch = useSelector((store) => store?.onBoarding?.secondBranch);
  const isLoading = useSelector((store) => store?.onBoarding?.isLoading);
  const navigate = useNavigate();
  const type = useSelector((store) => store?.onBoarding?.type);
  const successUuid = useSelector(state => state?.onBoarding?.successUuid)
  const isPremium = useSelector(state => state?.onBoarding?.isPremium)
  const stepLabels = useMemo(() =>  secondBranch ? [
    "Choose Your Immediate Goal",
    "Choose what describes you best",
    "Enter your target job role",
    "Choose the path that works best for you",
    "Finalise & Begin Your Journey",
  ]:[
    "Choose Your Immediate Goal",
    "Choose what describes you best",
    "Enter your target job role",
    "Choose the path that works best for you",
    "Pick your course topic",
    "Finalise & Begin Your Journey",
  ], [secondBranch]);

  const handleSetStep = (step) => {
    dispatch({type: SET_ONBOARDING_STEP, payload: step});
  }

  console.log(stepLabels, 'stepLabels', secondBranch)

  useEffect(() => {
    //dispatch({type: SET_ONBOARDING_STEP, payload: 1});
    dispatch({type: SET_ONBOARDING_IS_LOADING, payload: false});
  },[dispatch])

  useEffect(() => {
    dispatch(getProductById(32 , (successObj)=>{
      dispatch({type: SET_ONBOARDING_X_PRODUCT, payload: successObj});
    }, (errorObj)=>{
      console.log(errorObj, 'errorObj')
    }))
    dispatch(getProductById(31 , (successObj)=>{
      dispatch({type: SET_ONBOARDING_MAX_PRODUCT, payload: successObj});
    }, (errorObj)=>{
      console.log(errorObj, 'errorObj')
    }))
  },[dispatch])

  useEffect(() => {
    dispatch(checkUserAccess((successObj)=>{
      if(successObj?.is_onboarded === true){
        if(type === "cv"){
          window.location.href = `https://resume.learntube.ai`
          return;
        }
        else if(type === "job"){
          navigate('/job-application-guides')
          return;
        }
        else if(type === "course" && isPremium){
          window.location.href = `https://personalise.learntube.ai/onboarding/loader-1?uuid=${successUuid}`
          return;
        }
        navigate('/courses')
      }
    }))
  },[dispatch, navigate])

  return (
    <div
      className="relative min-h-screen w-full px-4 pt-4 flex flex-col items-center justify-between "
      style={{
        background:
          "radial-gradient(circle, #012744 0%, #010D17 100%)",
      }}
    >
      <div className="flex flex-1 w-full  flex-col items-center justify-start">
        <div className="w-full md:max-w-2xl   mx-auto h-full flex items-center justify-center">
          <NewLogo />
        </div>
        <div className="flex flex-1 w-full md:max-w-2xl md:mx-auto">
            {!isLoading ? <div className="flex flex-col w-full items-center justify-start">
              <div className="mt-6 flex w-full items-start justify-center">
                <StepProgressBar stepLabels={stepLabels} currentStep={step} />
              </div>
              <div className="mt-8 flex flex-col w-full items-center justify-between flex-1">
                <div className="flex flex-col w-full items-center justify-start">
                  {step === 1 && <StepOne setStep={handleSetStep} />}
                  {step === 2 && <StepTwo setStep={handleSetStep} />}
                  {step === 3 && <StepThree setStep={handleSetStep} />}
                  {step === 4 && <StepFour setStep={handleSetStep} />}
                  {step === 5 && <StepFive handleSetStep={handleSetStep}/>}
                  {step === 6 && <FourFlows/>}
                </div>
            </div> 

            </div>: <OnboardingLoaders/> }
            {/* <CertificateLoader/>
            {<CourseLoader/>} */}

            {step === 3 && <div className="absolute bottom-4 left-0 w-full md:left-1/2 md:-translate-x-1/2 md:max-w-2xl md:max-h-[200px] overflow-hidden">
              <div className="relative">
                <BottomScroll />
                <div className="w-full h-[82px] absolute bottom-0 left-0" style={{ background: 'linear-gradient(to top, #0B1D2B 0%, rgba(11, 29, 43, 0) 100%)' }}/>
              </div>
            </div>}
        </div>
      </div>

      {step <=2 && <div className="my-4">
            <PersonalisationLoader text={step ===1 ? "Firing up personalisation engine..." : "Analysing your profile to match it with top paths…"} />
      </div>}
    </div>
  );
};

export default OnboardingPage25;
